exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.InventarioSimConecta\n  div.ag-layout-auto-height:nth-child(2)\n  > div:nth-child(1)\n  > div:nth-child(1)\n  > div:nth-child(1) {\n  display: none;\n}\n.InventarioSimConecta\n  div.ag-layout-auto-height:nth-child(3)\n  > div:nth-child(1) {\n  display: none;\n}\n.InventarioSimConecta\n  div.ag-layout-auto-height:nth-child(2)\n  > div:nth-child(1)\n  > div:nth-child(5)\n  > div:nth-child(1) {\n  display: none;\n}\n", ""]);

// exports
